import { render } from "./footer.vue?vue&type=template&id=281611b6"
const script = {}

import exportComponent from "/home/aaicom7/repositories/prod/AAI-FMS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__